import { useState } from 'react';

const StudentNotifications = () => {
  const [filter, setFilter] = useState('all');
  const notifications = []; // Will be populated from API when endpoint is available

  const filtered = filter === 'all' ? notifications : notifications.filter((n) => n.type === filter);

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-black text-slate-800">Notifications</h2>
        <div className="flex gap-2">
          {['all', 'result', 'payment', 'event', 'info'].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-4 py-2 rounded-xl text-xs font-semibold capitalize transition-colors ${
                filter === f
                  ? 'bg-emerald-600 text-white'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        {filtered.length > 0 ? (
          <div className="divide-y divide-slate-100">
            {filtered.map((notif) => (
              <div key={notif.id} className="p-5 hover:bg-slate-50 transition-colors">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-bell text-slate-400" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="font-bold text-slate-800 text-sm">{notif.title}</h4>
                      <span className="text-xs text-slate-400">{notif.date}</span>
                    </div>
                    <p className="text-sm text-slate-500">{notif.message}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="p-12 text-center">
            <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-bell-slash text-2xl text-slate-300" />
            </div>
            <h3 className="font-bold text-slate-600 mb-1">No Notifications</h3>
            <p className="text-sm text-slate-400">You have no notifications at the moment.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentNotifications;

